import { render, staticRenderFns } from "./UploadUserStories.vue?vue&type=template&id=20245026&scoped=true"
import script from "./UploadUserStories.vue?vue&type=script&lang=js"
export * from "./UploadUserStories.vue?vue&type=script&lang=js"
import style0 from "./UploadUserStories.vue?vue&type=style&index=0&id=20245026&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20245026",
  null
  
)

export default component.exports